import { UserPreferencesConfig } from 'softcat:config/user-preferences.ts';
import { SoftcatApiConfigConfigVersion, SoftcatApiConfigEntitlement, SoftcatApiConfigPlatform } from 'softcat:types/softcat-api.ts';
import { SearchParameterUtils } from 'softcat:utils/search-parameters.ts';
import { SoftcatApiUtils } from 'softcat:utils/softcat-api.ts';

const findAllConfigVersions = async (): Promise<SoftcatApiConfigConfigVersion[]> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.get<SoftcatApiConfigConfigVersion[]>(`/config/configversions?${parameters}`);
};

const findAllEntitlements = async (): Promise<SoftcatApiConfigEntitlement[]> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.get<SoftcatApiConfigEntitlement[]>(`/config/entitlements?${parameters}`);
};

const findAllPlatforms = async (): Promise<SoftcatApiConfigPlatform[]> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.get<SoftcatApiConfigPlatform[]>(`/config/platforms?${parameters}`);
};

const updateAllConfigVersions = async (data: SoftcatApiConfigConfigVersion[]): Promise<SoftcatApiConfigConfigVersion[]> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.post<SoftcatApiConfigConfigVersion[]>(`/config/configversions?${parameters}`, { body: data });
};

const updateAllEntitlements = async (data: SoftcatApiConfigEntitlement[]): Promise<SoftcatApiConfigEntitlement[]> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.post<SoftcatApiConfigEntitlement[]>(`/config/entitlements?${parameters}`, { body: data });
};

const updateAllPlatforms = async (data: SoftcatApiConfigPlatform[]): Promise<SoftcatApiConfigPlatform[]> => {
    const territory = localStorage.getItem(UserPreferencesConfig.TerritoryStorageKey);
    const parameters = new URLSearchParams(SearchParameterUtils.removeEmptySearchParameters({ territory: `${territory}` }));

    return SoftcatApiUtils.post<SoftcatApiConfigPlatform[]>(`/config/platforms?${parameters}`, { body: data });
};

export const ConfigService = {
    findAllConfigVersions,
    findAllEntitlements,
    findAllPlatforms,
    updateAllConfigVersions,
    updateAllEntitlements,
    updateAllPlatforms,
};
